import Component from '@bythepixel/component-loader';

export default class CopyCurrentUrl extends Component {
  static selector = '[data-comp-copy-current-url]';

  constructor(el) {
    super(el);

    this.init();
  }

  init() {
    this.$container.addEventListener('click', () => {
      // Disabling compat/compat rule because `navigator` isn't supported in Safari versions from 2016 and older,
      // which I don't think should be in use at this point

      // eslint-disable-next-line no-undef
      navigator.clipboard.writeText(window.location.href).then(() => {
        // eslint-disable-next-line no-alert
        alert('URL copied to clipboard');
      }, (err) => {
        console.error('Async: Could not copy text: ', err);
      });
    });
  }
}
